import { Box, Button, ButtonGroup, Input } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const parseKeywordFromUrl = search => {
  const params = new URLSearchParams(search);
  return params.get('keywords') || '';
};

const SearchFiltersKeyword = props => {
  const location = useLocation();
  const inputRef = useRef(null);

  const { updateQueryParams } = props;

  // ---- LOCAL STATE (fast UI)
  const [keywords, setKeywords] = useState(() => parseKeywordFromUrl(location.search));

  // ---- URL → STATE (back/forward/external changes)
  useEffect(() => {
    setKeywords(parseKeywordFromUrl(location.search));
  }, [location.search]);

  const handleSearch = () => {
    updateQueryParams({
      keywords: keywords || null,
    });
  };

  const handleClear = () => {
    setKeywords('');
    updateQueryParams({ keywords: null });
    inputRef.current?.focus();
  };

  return (
    <Box pt={0}>
      <Input
        mt={0}
        ref={inputRef}
        value={keywords}
        placeholder="yoga, boxing, beginner pilates..."
        variant="outline"
        w="100%"
        color="almostBlack"
        _placeholder={{ color: 'gray.500' }}
        onChange={e => setKeywords(e.currentTarget.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
      />
      <ButtonGroup mt={'1rem'}>
        <Button disabled={!keywords} onClick={handleSearch} rounded={'3xl'}>
          Apply
        </Button>
        {keywords && (
          <Button variant="ghost" onClick={handleClear}>
            Clear
          </Button>
        )}
      </ButtonGroup>
    </Box>
  );
};

export default SearchFiltersKeyword;
